import { SET_SERVICES } from "../actions/serviceActions";

const initialState = {
  services: null,
};

const serviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SERVICES:
      return {
        services: action.payload,
      };

    default:
      return state;
  }
};

export default serviceReducer;
